import React, { useState } from "react"; // Add useState import
import { useNavigate, } from "react-router-dom";
import MenuComponent from "../../components/MenuComponent";
import {
  Box,
  Typography,
  Container,
  IconButton,
  useMediaQuery,
  Paper,
} from "@mui/material";
import MoreVert from "@mui/icons-material/MoreVert";
import ChevronLeftOutlined from "@mui/icons-material/ChevronLeftOutlined";
import FileTreeView from "../../components/Documents/FileTreeView";
const MultiLayerFolder = () => {
  const navigate = useNavigate();
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const [drawerOpen, setDrawerOpen] = useState(false); // State to manage Drawer open/close

  const handleDrawerToggle = () => {
    setDrawerOpen(!drawerOpen); // Toggle Drawer visibility
  };
  return (
    <Container
      maxWidth="xs"
      sx={{
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#ecf0f7",
      }}
    >
      <Box
        sx={{
          height: "129px",
          backgroundColor: "#1C1468",
          color: "white",
          display: "flex",
          alignItems: "center",
          marginLeft: "-24px",
          marginRight: "-24px",
          zIndex: 3,
          justifyContent: "space-between",
          position: "fixed",
          width: isNonMobile ? "444px" : "calc(100vw + 10px)",
        }}
      >
        <IconButton
          edge="start"
          sx={{ marginLeft: "10px" }}
          color="inherit"
          onClick={() => navigate("/")}
        >
          <ChevronLeftOutlined />
        </IconButton>

        <Typography sx={{ fontSize: "16px" }} variant="h5" fontWeight="bold">
          Documents
        </Typography>

        <IconButton
          edge="end"
          color="inherit"
          sx={{ marginRight: "15px" }}
          onClick={handleDrawerToggle}
        >
          <MoreVert />
        </IconButton>
        <MenuComponent
          open={drawerOpen} // Drawer visibility
          onClose={handleDrawerToggle} // Handler to close the drawer
        />
      </Box>
      <Paper sx={{ backgroundColor: "#fff", padding: 3, marginTop: "159px" }}>
        <FileTreeView />
      </Paper>
    </Container>
  );
};
export default MultiLayerFolder;
